import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PartnerService } from '../../../services/partner.service';
import { PartnerPro } from 'src/app/shared/models/partner-pro';
import { UserService } from 'src/app/shared/services/user.service';
import { UserProDataSet } from 'src/app/shared/models/user-pro-data-set';
import { ImportService } from 'src/app/shared/services/import.service';
import { MatDialog } from '@angular/material/dialog';
import { SliderDialogService } from 'src/app/shared/services/slider-dialog.service';
import { Router } from '@angular/router';
import { ApproveProsModalComponent } from '../../_modals/approve-pros-modal/approve-pros-modal.component';
import { ExportProModalComponent } from '../../_modals/export-pro-modal/export-pro-modal.component';
import { ProDataFilterModalComponent } from '../../_modals/pro-data-filter-modal/pro-data-filter-modal.component';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-pro-import-details-table',
  templateUrl: './pro-import-details-table.component.html',
  styleUrls: ['./pro-import-details-table.component.scss']
})
export class ProImportDetailsTableComponent implements OnInit {

  @Input() dataSource;
  @Input() importExists;

  subs: Subscription[] = [];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // dataSource: MatTableDataSource<any>;

  @ViewChild('scrollContainer') scrollContainerRef!: ElementRef;

  loading: boolean = false;

  selectedDataSet: UserProDataSet;

  selectedProType: string;


  displayedColumns = [
    'position',
    'year',
    'quarter',
    'distributionYear',
    'distributionQuarter',
    'statementRecipientId',
    'statementRecipientName',
    'partyId',
    'partyName',
    'legalEarnerPartyId',
    'legalEarnerPartyName',
    'performanceSource',
    'musicUserGenre',
    'musicUser',
    'networkService',
    'performanceStartDate',
    'performanceEndDate',
    'surveyType',
    'dayPartCode',
    'show',
    'episodeName',
    'workId',
    'workTitle',
    'allocationPercentage',
    'classificationCode',
    'numberOfPlays',
    'performanceType',
    'duration',
    'performingArtist',
    'composerName',
    'eeShare',
    'credits',
    'royalty',
    // 'adj_usd',
    'premiumCredits',
    'premiumRoyalty',
    'adjustmentIndicator',
    'adjustmentReasonCode',
    'originalDistributionDate',
    'roleType',
    'typeOfRight',
    'territory',
    'licensor',
    'programCode',
    'performanceQuarter',
    'countryName',
    'fileType',
    'licensorCode',
    'revenueClassCode',
    'revenueClassDescription',
    'adjustmentDistributionDate',
    'currentActivityAmt',
    'hitSongBonus',
    'standardsBonus',
    'foreignSocietyAdjustment',
    'perfDate',
    'wOrP',
    'showName',
    'paymentType',
    'chart',
    'payNumber',
    'synd',
    'strip',
    'performance',
    'occur',
    'societyAbbrv',
    'societyCountry'
  ];

  allPartnerPros: PartnerPro[] = [];
  approvedPartnerPros: PartnerPro[] = [];

  proType: string;
  proYear: number;
  proQuarter: string;

  tablePage: number = 1;
  tablePageSize: number = 100;

  tableData: any;

  sortedBy: string;
  reverseSort = false;

  columns = [];

  proTypes = [];
  proYears = [];
  proQuarters = [];

  proStatus = '';

  getProsBtnClicked = false;

  // flag to prevent exponential looping; prevents call from happening more than once at a time
  isFetchingPros = false;
  getPartnerProsSubscription;

  constructor(private partnerService: PartnerService, private userService: UserService, private importService: ImportService, public dialog: MatDialog, private sliderDialogService: SliderDialogService,
              private router: Router) { }

  ngOnInit() {
    // header data init
    this.proTypes = this.importService.importTypes;

    //default to first option in list
    this.proType = this.proTypes[0];
    this.setProType();

    this.proYears = this.importService.importYears;

    //default to first option in list
    this.proYear = this.proYears[0];
    this.setProYear();
    
    this.proQuarters = this.importService.importQuarters;

    //default to first option in list
    this.proQuarter = this.proQuarters[0];
    this.setProQuarter();

    //track selected pro data status
    this.subs.push(this.partnerService.proStatus$.subscribe((x) => {
      this.proStatus = x;
    }));
    // end header data init

    this.columns = this.partnerService.masterColumns.slice();

    //determine th9e selected pro type
    this.subs.push(this.partnerService.proType$.subscribe((x) => {
      this.selectedProType = x;

      //get data set for current user
      this.partnerService.getUserDataSets(this.userService.currentUser.id).subscribe(resDataSets => {
        let userDataSets = resDataSets;

        this.selectedDataSet = userDataSets.find(set => set.proType == this.selectedProType);

        this.partnerService.setCurrentUserSelectedDataSet(this.selectedDataSet);

        this.filterColumnsPerDataSet();

      })
    }))

    //track type, year and quarter - gets partner pros accordingly

    this.subs.push(this.partnerService.proType$.subscribe((resType) => {
      this.proType = resType;

    this.subs.push(this.partnerService.proYear$.subscribe((resYear) => {
      this.proYear = resYear;

    this.subs.push(this.partnerService.proQuarter$.subscribe((resQuarter) => {
      this.proQuarter = resQuarter;

      //set table to page 1;
      this.partnerService.setTablePage(1);

      this.partnerService.setTablePageSize(100);

      //track page
      this.subs.push(this.partnerService.tablePage$.subscribe((x) => {
        this.tablePage = x;

        //track page size
        this.subs.push(this.partnerService.tablePageSize$.subscribe((x) => {
          this.tablePageSize = x;

        }));

        // page changed - update table
        // timeout give both page and pageSize time to update
        // setTimeout(() => {
        //   this.getPros();

        // }, 500);
      }));

      this.getProsBtnClicked = false;
      this.allPartnerPros = [];


        }));
      }));
    }));

  }


  ngAfterViewInit() {

    if(this.dataSource)
      this.dataSource.sort = this.sort;

    // Trigger the scrollbar component's method after the view is initialized
    this.scrollContainerRef.nativeElement.addEventListener('scroll', (event: Event) => {
      const scrollBarComponent = this.scrollContainerRef.nativeElement.querySelector('app-custom-scroll-bar');
      if (scrollBarComponent) {
        scrollBarComponent.onScroll(event);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.getPartnerProsSubscription) {
      this.getPartnerProsSubscription.unsubscribe();
    }
    this.partnerService.fetchingPros = false;
    this.partnerService.exportedProIDs = [];

    this.subs.forEach(x => x.unsubscribe());
  }

  getPros(sortBy?: string) {
    if (!this.partnerService.fetchingPros) {
      this.partnerService.fetchingPros = true;
      //check if reversing sort order
      if (this.sortedBy == sortBy) {
        this.reverseSort = !this.reverseSort;
      }

      this.sortedBy = sortBy;

      if (this.proType && this.proYear && this.proQuarter) {

        this.loading = true;

        //reset
        this.allPartnerPros = [];

        this.getPartnerProsSubscription = this.partnerService.getPartnerPros(this.proType, this.proYear, this.proQuarter, this.tablePage, this.tablePageSize, sortBy, this.reverseSort).subscribe(resPartnerPros => {

          this.tableData = resPartnerPros;
          // new MatTableDataSource<any>(res);

          this.partnerService.exportedProIDs = resPartnerPros.data.map(item => item.id);
          this.allPartnerPros = resPartnerPros.data.map(item => PartnerPro.mapProperties(item));

          //this.dataSource = new MatTableDataSource(this.allPartnerPros);

          if (this.allPartnerPros.length > 1) {
            this.importExists = true;
          } else {
            this.importExists = false;
          }

          //set status for header
          if (this.allPartnerPros.some(pro => pro.isApproved == false && pro.pendingApproval == false)) {
            //still waiting for approval request
            this.partnerService.setProStatus("Incomplete");
          }
          else if (this.allPartnerPros.some(pro => pro.isApproved == false)) {
            //some must still be awaiting approval
            this.partnerService.setProStatus("Pending Approval");
          }
          else if (this.allPartnerPros.length > 0) {
            //all have been approved
            this.partnerService.setProStatus("Completed");
          }
          else {
            this.partnerService.setProStatus("");
          }

          this.loading = false;
          this.getProsBtnClicked = true;
          this.partnerService.fetchingPros = false;
        },
        // error => {
        //   console.log(error);
        //   this.loading = false;
        //   this.partnerService.fetchingPros = false;
        // }
      );
      }
    }
  }

  onScroll(event: Event) {
    // Pass the scroll event to the custom scrollbar component if needed
  }

  sortTable(col: string) {
    let isReversed = true;

    this.allPartnerPros.sort((a, b) => {
      let valueA, valueB;

      switch (col) {
        case 'YEAR':
          valueA = a.year;
          valueB = b.year;
          break;
        case 'QUARTER':
          valueA = a.quarter;
          valueB = b.quarter;
          break;
        case 'DISTRIBUTION YEAR':
          valueA = a.distributionYear;
          valueB = b.distributionYear;
          break;
        case 'DISTRIBUTION QUARTER':
          valueA = a.distributionQuarter;
          valueB = b.distributionQuarter;
          break;
        case 'STATEMENT RECIPIENT ID':
          valueA = a.statementRecipientId;
          valueB = b.statementRecipientId;
          break;
        case 'STATEMENT RECIPIENT NAME':
          valueA = a.statementRecipientName;
          valueB = b.statementRecipientName;
          break;
        case 'PARTY ID':
          valueA = a.partyId;
          valueB = b.partyId;
          break;
        case 'PARTY NAME':
          valueA = a.partyName;
          valueB = b.partyName;
          break;
        case 'LEGAL EARNER PARTY ID':
          valueA = a.legalEarnerPartyId;
          valueB = b.legalEarnerPartyId;
          break;
        case 'LEGAL EARNER PARTY NAME':
          valueA = a.legalEarnerPartyName;
          valueB = b.legalEarnerPartyName;
          break;
        case 'PERFORMANCE SOURCE':
          valueA = a.performanceSource;
          valueB = b.performanceSource;
          break;
        case 'MUSIC USER GENRE':
          valueA = a.musicUserGenre;
          valueB = b.musicUserGenre;
          break;
        case 'MUSIC USER':
          valueA = a.musicUser;
          valueB = b.musicUser;
          break;
        case 'NETWORK SERVICE':
          valueA = a.networkService;
          valueB = b.networkService;
          break;
        case 'PERFORMANCE START DATE':
          valueA = new Date(a.performanceStartDate);
          valueB = new Date(b.performanceStartDate);
          break;
        case 'PERFORMANCE END DATE':
          valueA = new Date(a.performanceEndDate);
          valueB = new Date(b.performanceEndDate);
          break;
        case 'SURVEY TYPE':
          valueA = a.surveyType;
          valueB = b.surveyType;
          break;
        case 'DAY PART CODE':
          valueA = a.dayPartCode;
          valueB = b.dayPartCode;
          break;
        case 'SHOW':
          valueA = a.show?.name;
          valueB = b.show?.name;
          break;
        case 'EPISODE NAME':
          valueA = a.episodeName;
          valueB = b.episodeName;
          break;
        case 'WORK ID':
          valueA = a.workId;
          valueB = b.workId;
          break;
        case 'WORK TITLE':
          valueA = a.workTitle;
          valueB = b.workTitle;
          break;
        case 'ALLOCATION PERCENTAGE':
          valueA = a.allocationPercentage;
          valueB = b.allocationPercentage;
          break;
        case 'CLASSIFICATION CODE':
          valueA = a.classificationCode;
          valueB = b.classificationCode;
          break;
        case 'NUMBER OF PLAYS':
          valueA = a.numberOfPlays;
          valueB = b.numberOfPlays;
          break;
        case 'PERFORMANCE TYPE':
          valueA = a.performanceType;
          valueB = b.performanceType;
          break;
        case 'DURATION':
          valueA = a.duration;
          valueB = b.duration;
          break;
        case 'PERFORMING ARTIST':
          valueA = a.performingArtist;
          valueB = b.performingArtist;
          break;
        case 'COMPOSER NAME':
          valueA = a.composerName;
          valueB = b.composerName;
          break;
        case 'EE SHARE':
          valueA = a.eeShare;
          valueB = b.eeShare;
          break;
        case 'CREDITS':
          valueA = a.credits;
          valueB = b.credits;
          break;
        case 'ROYALTY':
          valueA = a.royalty;
          valueB = b.royalty;
          break;
        case 'PREMIUM CREDITS':
          valueA = a.premiumCredits;
          valueB = b.premiumCredits;
          break;
        case 'PREMIUM ROYALTY':
          valueA = a.premiumRoyalty;
          valueB = b.premiumRoyalty;
          break;
        case 'ADJUSTMENT INDICATOR':
          valueA = a.adjustmentIndicator;
          valueB = b.adjustmentIndicator;
          break;
        case 'ADJUSTMENT REASON CODE':
          valueA = a.adjustmentReasonCode;
          valueB = b.adjustmentReasonCode;
          break;
        case 'ORIGINAL DISTRIBUTION DATE':
          valueA = new Date(a.originalDistributionDate);
          valueB = new Date(b.originalDistributionDate);
          break;
        case 'ROLE TYPE':
          valueA = a.roleType;
          valueB = b.roleType;
          break;
        case 'TYPE OF RIGHT':
          valueA = a.typeOfRight;
          valueB = b.typeOfRight;
          break;
        case 'TERRITORY':
          valueA = a.territory;
          valueB = b.territory;
          break;
        case 'LICENSOR':
          valueA = a.licensor;
          valueB = b.licensor;
          break;
        case 'PROGRAM CODE':
          valueA = a.programCode;
          valueB = b.programCode;
          break;
        case 'PERFORMANCE QUARTER':
          valueA = a.performanceQuarter;
          valueB = b.performanceQuarter;
          break;
        case 'COUNTRY NAME':
          valueA = a.countryName;
          valueB = b.countryName;
          break;
        case 'FILE TYPE':
          valueA = a.fileType;
          valueB = b.fileType;
          break;
        case 'LICENSOR CODE':
          valueA = a.licensorCode;
          valueB = b.licensorCode;
          break;
        case 'REVENUE CLASS CODE':
          valueA = a.revenueClassCode;
          valueB = b.revenueClassCode;
          break;
        case 'REVENUE CLASS DESCRIPTION':
          valueA = a.revenueClassDescription;
          valueB = b.revenueClassDescription;
          break;
        case 'ADJUSTMENT DISTRIBUTION DATE':
          valueA = new Date(a.adjustmentDistributionDate);
          valueB = new Date(b.adjustmentDistributionDate);
          break;
        case 'CURRENT ACTIVITY AMOUNT':
          valueA = a.currentActivityAmt;
          valueB = b.currentActivityAmt;
          break;
        case 'HIT SONG BONUS':
          valueA = a.hitSongBonus;
          valueB = b.hitSongBonus;
          break;
        case 'STANDARDS BONUS':
          valueA = a.standardsBonus;
          valueB = b.standardsBonus;
          break;
        case 'FOREIGN SOCIETY ADJUSTMENT':
          valueA = a.foreignSocietyAdjustment;
          valueB = b.foreignSocietyAdjustment;
          break;
        case 'PERFORMANCE DATE':
          valueA = new Date(a.perfDate);
          valueB = new Date(b.perfDate);
          break;
        case 'W OR P':
          valueA = a.wOrP;
          valueB = b.wOrP;
          break;
        case 'SHOW NAME':
          valueA = a.showName;
          valueB = b.showName;
          break;
        case 'PAYMENT TYPE':
          valueA = a.paymentType;
          valueB = b.paymentType;
          break;
        case 'CHART':
          valueA = a.chart;
          valueB = b.chart;
          break;
        case 'PAY NUMBER':
          valueA = a.payNumber;
          valueB = b.payNumber;
          break;
        case 'SYND':
          valueA = a.synd;
          valueB = b.synd;
          break;
        case 'STRIP':
          valueA = a.strip;
          valueB = b.strip;
          break;
        case 'PERFORMANCE':
          valueA = a.performance;
          valueB = b.performance;
          break;
        case 'OCCUR':
          valueA = a.occur;
          valueB = b.occur;
          break;
        case 'SOCIETY ABBRV':
          valueA = a.societyAbbrv;
          valueB = b.societyAbbrv;
          break;
        case 'SOCIETY COUNTRY':
          valueA = a.societyCountry;
          valueB = b.societyCountry;
          break;
        default:
          return 0; // If the column name doesn't match, don't change the order
      }

      // Check if the current sorting is ascending
      if (valueA < valueB) isReversed = false;
      if (valueA > valueB) isReversed = true;

      if (valueA < valueB) return -1;
      if (valueA > valueB) return 1;
      return 0;
    });

    // If already sorted in ascending order, reverse the array
    if (isReversed) {
      this.allPartnerPros.reverse();
    }
  }


  filterColumnsPerDataSet() {


    //first, determine & track the selected data set
    this.partnerService.currentUserSelectedDataSet$.subscribe((x) => {
      this.selectedDataSet = x;

      if (this.selectedDataSet) {
        //we have a data set, apply filtering to the table
        //NOTE: BACKEND FILTERING IS APPLIED TO THE RETURNED DATA - THIS WILL JUST BE USED FOR 
        //UI RENDERING PURPOSES

        //reset columns back to all, we will filter from here
        this.columns = this.partnerService.masterColumns.slice()

        //sort alphabetically
        this.selectedDataSet.properties.sort((a, b) => {
          return a.propertyName.localeCompare(b.propertyName);
        });

        this.selectedDataSet.properties.forEach(prop => {
          //check if isSelected = false, if so, remove
          //this property from the column list
          if (prop.isSelected != true || prop.isRestricted) {
            const index = this.columns.findIndex(item => item.name.toLowerCase() === prop.propertyName.toLowerCase());

            if (index > -1) {
              this.columns.splice(index, 1);
            }
            else{
              //test break point
              var test = prop.propertyName;
            }
          }
        })

      }
      else {
        //there is not saved settings for this pro type and user
        //all columns will be displayed by default
        //THIS MAY REQUIRE A DIFFERENT DEFAULT FOR SECURITY REASONS
      }

    })
  }

  //determines if the column data should be displayed
  checkColumns(columnHeader: string): boolean {
    return this.columns.some(item => item.value == columnHeader);
  }

  setProType() {
    this.partnerService.setProType(this.proType);
  }

  setProYear() {
    this.partnerService.setProYear(this.proYear);
  }

  setProQuarter() {
    this.partnerService.setProQuarter(this.proQuarter);
  }


  approvePro(){
    const dialogRef = this.dialog.open(ApproveProsModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      
      // this.partnerService.getPartnerGroups().subscribe((x) => {
      //   this.partnerService.setPartnerGroups(x);
      // });

    });
  }

  exportPro(){
    const dialogRef = this.dialog.open(ExportProModalComponent, {
      data: {
        pros: [{
          type: this.proType,
          quarter: this.proQuarter,
          year: this.proYear,
          pdfSelected: false,
          csvSelected: false,
          xlsxSelected: false
        }],
        partnerId: null
      }
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      
      // this.partnerService.getPartnerGroups().subscribe((x) => {
      //   this.partnerService.setPartnerGroups(x);
      // });

    });
  }

  showFilterPanel(){
    this.sliderDialogService.close(true);
    this.sliderDialogService.open(ProDataFilterModalComponent, {
      width: "600px",
      title: "FILTERS",
      panelClass: "edit-track-dialog",
      data: {  }
    }, (user) => {

    });
  }

  /**
   * For step 1 - shows the pro-import view
   */
  openProImport() {
    var variablesSet = this.importService.areAllImportVariablesSet();
    if (this.proType && this.proYear && this.proQuarter) {
      this.router.navigate(['data/pro/import'])
    }

    // if(variablesSet){
    //   //navigate to import view
    // }
  }



}
